import { z } from 'zod';
import { messages } from './validationMessages';

const PartSchemaV2 = z.object({
  partId: z.string().min(1, messages.required),
  name: z.string().min(1, messages.required),
  price: z
    .number()
    .min(0.01, messages.required)
    .refine((value) => value === undefined || value >= 0, {
      message: messages.noNegative,
    }),
  quantity: z
    .number({
      invalid_type_error: messages.mustBeNumber,
    })
    .int(messages.mustBeInteger)
    .refine((value) => value > 0, {
      message: messages.mustBePositive,
    })
    .default(1),
  description: z.string().optional(),
});

const FormSchemaV2 = z.object({
  types: z.array(z.enum(['corrective', 'preventive'])).min(1, messages.required),
  vehicleId: z.string().min(1, messages.required),
  occurrenceAt: z.string().min(1, messages.required),
  totalPrice: z.number().default(0),
  odometerInKms: z.string().min(1, messages.required),
  parts: z.array(PartSchemaV2).min(1, messages.minItems),
  recurrencesHasDone: z.array(z.string()).optional(),
  description: z.string().optional(),
});

const PartSchema = PartSchemaV2.extend({
  quantity: z
    .number({
      invalid_type_error: messages.mustBeNumber,
    })
    .int(messages.mustBeInteger)
    .refine((value) => value >= 0, {
      message: messages.noNegative,
    })
    .default(0)
    .optional(),
  price: z
    .number()
    .refine((value) => value === undefined || value >= 0, {
      message: messages.noNegative,
    })
    .optional(),
});

const FormSchema = FormSchemaV2.extend({
  totalPrice: z
    .number()
    .optional()
    .refine((value) => value === undefined || value >= 0, {
      message: messages.noNegative,
    }),
  parts: z.array(PartSchema),
}).partial({
  parts: true,
});

type FormValuesV2 = z.infer<typeof FormSchemaV2>;
type FormValues = z.infer<typeof FormSchema>;

export { FormSchemaV2, type FormValuesV2, FormSchema, type FormValues };
